

import React from 'react';
import { StatCardWidget } from '../widgets';
import { Calendar, FileText, TrendingUp, DollarSign } from 'lucide-react';
import { formatCurrency } from '@/lib/data';

interface StatsSectionProps {
  stats: any;
  loading: boolean;
}

export function StatsSection({ stats, loading }: StatsSectionProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <StatCardWidget
        title="Total Revenue"
        value={formatCurrency(stats?.total_revenue || 0)}
        subtitle="This month"
        icon={<DollarSign className="w-5 h-5" />}
        color="gold"
        loading={loading}
      />
      <StatCardWidget
        title="Active Events"
        value={stats?.total_events || 0}
        subtitle="Ongoing"
        icon={<Calendar className="w-5 h-5" />}
        color="blue"
        loading={loading}
      />
      <StatCardWidget
        title="Pending Enquiries"
        value={stats?.pending_enquiries || 0}
        subtitle="New enquiries"
        icon={<FileText className="w-5 h-5" />}
        color="purple"
        loading={loading}
      />
      <StatCardWidget
        title="Net Profit"
        value={formatCurrency(stats?.net_profit || 0)}
        subtitle="This month"
        icon={<TrendingUp className="w-5 h-5" />}
        color="green"
        loading={loading}
      />
    </div>
  );
}
